import { render, staticRenderFns } from "./ClientInitialUsers.vue?vue&type=template&id=d9231d26"
import script from "./ClientInitialUsers.vue?vue&type=script&lang=js"
export * from "./ClientInitialUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports